import { rootEventBus, EnumRootEventBus } from "../../../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "../../EventBus";
import Checkbox from "../../../../../../../src/entities/UI/Checkbox/Checkbox";
import SwitcherButton from "../../../../../../../src/entities/UI/SwitcherButton/SwitcherButton";
import { PractiseModeQuestionCbConfig, PractiseSwitcherButtonStyles } from "../../../types/Config";
import addButton from "../helpers/addButtonHelper";
import { QuestionMode, QuestionType } from "../../../types/Enum";


export default class ButtonFactory {
  static genGoToTestModeButton(): SwitcherButton {
    let button: SwitcherButton;
    const onHandleFunc = () => {
      eventBus.emit(EnumEventBus.setQuestMode, QuestionMode.test)
      setTimeout(() => button.closeButton(), 200);
    }
    const onHandleSecondFunc = () => { };
    const sButtonStyle = PractiseSwitcherButtonStyles.gotoTestMode;
    button = addButton("Go To Test Mode", onHandleFunc, onHandleSecondFunc, sButtonStyle, undefined, false);
    return button;
  }
  static genGenRandomlyQuestionButton(): SwitcherButton {
    let button: SwitcherButton;
    const onHandleFunc = () => {
      rootEventBus.emit(EnumRootEventBus.cancelledCircleAnim);
      eventBus.emit(EnumEventBus.newQuestion);
      eventBus.emit(EnumEventBus.clearAll);
      setTimeout(() => button.closeButton(), 200);
    }
    const onHandleSecondFunc = () => { };
    const sButtonStyle = PractiseSwitcherButtonStyles.genRandomlyQuestion;
    button = addButton("Generate Randomly Question", onHandleFunc, onHandleSecondFunc, sButtonStyle, undefined, false);
    return button;
  }
  static genShowSolutionButton(): SwitcherButton {
    const onHandleFunc = () => eventBus.emit(EnumEventBus.setShowSolution, true);
    const onHandleSecondFunc = () => eventBus.emit(EnumEventBus.setShowSolution, false);
    const sButtonStyle = PractiseSwitcherButtonStyles.showSolution;
    return addButton("Show Solution", onHandleFunc, onHandleSecondFunc, sButtonStyle);
  }
  static genTracingPaperButton(): SwitcherButton {
    const onHandleFunc = () => eventBus.emit(EnumEventBus.setTracingMode, true);
    const onHandleSecondFunc = () => eventBus.emit(EnumEventBus.setTracingMode, false);
    const sButtonStyle = PractiseSwitcherButtonStyles.tracingPaper;
    const button = addButton("Tracing Paper", onHandleFunc, onHandleSecondFunc, sButtonStyle);
    eventBus.on(EnumEventBus.setTracingMode, v => !v ? button.closeButton() : "")
    return button;
  }
  static genAnimateButton(): SwitcherButton {
    let button: SwitcherButton;
    const onHandleFunc = () => {
      eventBus.emit(EnumEventBus.animateTracingPaper, true)
      setTimeout(() => button.closeButton(), 200);
    };
    const onHandleSecondFunc = () => eventBus.emit(EnumEventBus.animateTracingPaper, false);
    const sButtonStyle = PractiseSwitcherButtonStyles.animate;
    button = addButton("Animate", onHandleFunc, onHandleSecondFunc, sButtonStyle);
    button.visible = false;
    return button
  }
  static genHintButton(): SwitcherButton {
    const onHandleFunc = () => {
      eventBus.emit(EnumEventBus.animateHint, true);
      eventBus.emit(EnumEventBus.setTracingMode, false);
    };
    const onHandleSecondFunc = () => eventBus.emit(EnumEventBus.animateHint, false);
    const sButtonStyle = PractiseSwitcherButtonStyles.hint;
    return addButton("Show Hint", onHandleFunc, onHandleSecondFunc, sButtonStyle);
  }
  static genTypeCheckbox(type: QuestionType, _handleFunc: (v: boolean) => void): Checkbox {
    const config = PractiseModeQuestionCbConfig[type];
    const handleFunc = (l: string, v: boolean) => _handleFunc(v)
    const checkbox = new Checkbox(config.coord, config.label, config.color, true, handleFunc);
    checkbox.setChecked(true);
    checkbox.setScale(.7)
    return checkbox;
  }
}